export default "__VITE_ASSET__1768edda__"